// extracted by mini-css-extract-plugin
export default {"badge":"AthleteCategoryBadge_badge__XCjZo"};